import compose from 'ramda/src/compose';
import path from 'ramda/src/path';
import split from 'ramda/src/split';
import partialRight from 'ramda/src/partialRight';
var splitByDot = split('.');

var searchableComponent = function searchableComponent(boundedCallback) {
  return compose(partialRight(path, [boundedCallback()]), splitByDot);
};

export { searchableComponent };